import React, { useEffect } from 'react'
import { Container, Pagination, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {  fetchViewCompanies, fetchViewCompaniesPagination } from '../../../redux/action/companies/companies'
import default_image_url from '../../../redux/api/API'
import MainLoading from '../../../utils/MainLoading'
import HomeMainTitle from '../../homeTitle/HomeMainTitle'
import Wrapper from '../../homeWrapper/Wrapper'
import {FaEye} from 'react-icons/fa'
import {RiShoppingCartLine} from 'react-icons/ri'
import './style.scss'
import { Helmet } from 'react-helmet'
import { fetchAllAds } from '../../../redux/action/ads/getAds'
import { useTranslation } from 'react-i18next'

const Companies = (props) => {
    const dispatch = useDispatch()
    const companies = useSelector(state => state.companies_page)
    const all_ads = useSelector(state => state.all_ads)
    const {t} = useTranslation();

    useEffect(() => {
        if(!companies.companies_page.data) {
            dispatch(fetchViewCompanies())
        }
        if(!all_ads.all_ads.length) {
            dispatch(fetchAllAds())
        }
    }, [])

    const handlePaginate = (e) => {
        e.preventDefault()
        dispatch(fetchViewCompaniesPagination(e.target.href))
        window.scrollTo(0, 0)
    }

    return (
        <Wrapper>
            <Helmet>
                <title>غرفه‌ها - نمایشگاه مجازی</title>
            </Helmet>
            {companies.loading ? 
                <MainLoading />
            :   
                <Container>
                    <div className='mt-5'>
                        <HomeMainTitle>{t("dashboard_nav_companies")}</HomeMainTitle>
                        <Row>
                            <div className={all_ads.all_ads.length && all_ads.all_ads.filter(item => item.location === 'companies') ? 'col-lg-9' : 'col-lg-12'}>
                                <Row className='animate__animated animate__fadeInDown saloons_page_items'>
                                    {companies.companies_page.data && 
                                        companies.companies_page.data.length ? 
                                            companies.companies_page.data.map(company => (
                                                <div className='col-lg-4 company_item' key={company.id} >
                                                    <Link to={`/company/${company.id}`}>
                                                        {company.avatar ?
                                                            <img src={default_image_url+company.avatar} alt="company" />
                                                        :
                                                            <img src='/assets/img/shop.png' alt="company" />
                                                        }
                                                        <h1> {company.title} </h1>
                                                        <div className='company_card_items'>
                                                            <div className='company_card_item'><h6>{t("hall")} : </h6><h5>{company.saloon && company.saloon.name}</h5></div>
                                                            <div className='company_card_item'><h6>{t("CEO name")} : </h6><h5> {company.manager_name} </h5></div>
                                                            <div className='company_card_item'><h6>{t("location")} : </h6><h5>{company.province ? company.province+'، '+company.city : '-' }</h5></div>
                                                        </div>
                                                        <div className='company_card_footer'>
                                                            <div className='company_card_footer_item'><FaEye /><h5>{company.view_count} {t("visit")}</h5></div>
                                                            <div className='company_card_footer_item'><RiShoppingCartLine /><h5>{company.products_count} {t("product")}</h5></div>
                                                        </div>
                                                    </Link>  
                                                </div>
                                            ))
                                        :
                                            <h6 className='text-center'> {t("No company has been created yet")} </h6>
                                    }
                                </Row>
                                <div className='pagination_container mt-3'>
                                    {companies.companies_page &&
                                        <Pagination>
                                            {companies.companies_page.links ? companies.companies_page.links.map(link => (
                                                <Pagination.Item href={link.url} disabled={link.url ? false : true} active={link.active} key={link.label} onClick={id => {handlePaginate(id)}}>
                                                    {link.label.replace('&laquo;', '').replace('&raquo;', '')}
                                                </Pagination.Item>
                                            )) : ''}
                                        </Pagination>
                                    }
                                </div>
                            </div>
                            <div className='col-lg-3 ad-container mt-5'>
                                {all_ads.all_ads.filter(item => item.location === 'companies' & item.position === 'top').map(ad => (
                                    <a key={ad.id} href={`//${ad.url}`} target='_blank' rel="nofollow" className='full-size-ad-container'>
                                        <img src={default_image_url+ad.path} alt={ad.url} />
                                    </a>
                                ))}
                                {all_ads.all_ads.filter(item => item.location === 'companies' & item.position === 'bottom').map(ad => (
                                    <a key={ad.id} href={`//${ad.url}`} target='_blank' rel="nofollow" className='full-size-ad-container'>
                                        <img src={default_image_url+ad.path} alt={ad.url} />
                                    </a>
                                ))}
                            </div>
                        </Row>
                    </div>
                </Container>
            }
        </Wrapper>
    )
}

export default Companies
